var _g, _g2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3,3)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 20 C100 20 130 55 125 80 C140 60 138 40 132 30 C155 55 162 90 150 118 C142 138 124 158 100 165 C76 158 58 138 50 118 C38 90 45 55 68 30 C62 40 60 60 75 80 C70 55 100 20 100 20Z",
    fill: "#00FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3,-3)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 20 C100 20 130 55 125 80 C140 60 138 40 132 30 C155 55 162 90 150 118 C142 138 124 158 100 165 C76 158 58 138 50 118 C38 90 45 55 68 30 C62 40 60 60 75 80 C70 55 100 20 100 20Z",
    fill: "#FF00FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 20 C100 20 130 55 125 80 C140 60 138 40 132 30 C155 55 162 90 150 118 C142 138 124 158 100 165 C76 158 58 138 50 118 C38 90 45 55 68 30 C62 40 60 60 75 80 C70 55 100 20 100 20Z",
    fill: "white",
    stroke: "#FF00FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 75 C100 75 116 95 113 110 C120 100 119 88 115 82 C125 95 126 115 118 128 C113 138 107 144 100 146 C93 144 87 138 82 128 C74 115 75 95 85 82 C81 88 80 100 87 110 C84 95 100 75 100 75Z",
    fill: "none",
    stroke: "#CC00CC",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 75 C100 75 116 95 113 110 C120 100 119 88 115 82 C125 95 126 115 118 128 C113 138 107 144 100 146 C93 144 87 138 82 128 C74 115 75 95 85 82 C81 88 80 100 87 110 C84 95 100 75 100 75Z",
    fill: "none",
    stroke: "#00CCCC",
    strokeWidth: 1.5,
    transform: "translate(3,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.5540d2c91321211dd9580e7d49c8be13.svg";
export { ForwardRef as ReactComponent };